import React from 'react';
import BilanIconButton from './BilanIconButton';

interface OrangeCheckButtonProps {
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export default function OrangeCheckButton({ onClick }: OrangeCheckButtonProps) {
  return (
    <BilanIconButton
      aria-label="Ouvrir le bilan avec avertissement"
      iconType="tick_thick"
      onClick={onClick}
      size="xs"
      variantType="primary"
    />
  );
}
